/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';
import type { PlanWorkout } from './PlanWorkout';
import {
    PlanWorkoutFromJSON,
    PlanWorkoutFromJSONTyped,
    PlanWorkoutToJSON,
    PlanWorkoutToJSONTyped,
} from './PlanWorkout';

/**
 * 
 * @export
 * @interface PlanUnit
 */
export interface PlanUnit {
    /**
     * 
     * @type {string}
     * @memberof PlanUnit
     */
    idClient: string;
    /**
     * 
     * @type {string}
     * @memberof PlanUnit
     */
    name: string;
    /**
     * 
     * @type {Array<PlanWorkout>}
     * @memberof PlanUnit
     */
    workouts: Array<PlanWorkout>;
    /**
     * 
     * @type {string}
     * @memberof PlanUnit
     */
    nextUnitId?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanUnit
     */
    repeatCount?: number;
    /**
     * 
     * @type {string}
     * @memberof PlanUnit
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PlanUnit
     */
    sortKey: number;
    /**
     * 
     * @type {string}
     * @memberof PlanUnit
     */
    trainingDateIso?: string;
    /**
     * 
     * @type {HTTPLink}
     * @memberof PlanUnit
     */
    link?: HTTPLink;
}

/**
 * Check if a given object implements the PlanUnit interface.
 */
export function instanceOfPlanUnit(value: object): value is PlanUnit {
    if (!('idClient' in value) || value['idClient'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('workouts' in value) || value['workouts'] === undefined) return false;
    if (!('sortKey' in value) || value['sortKey'] === undefined) return false;
    return true;
}

export function PlanUnitFromJSON(json: any): PlanUnit {
    return PlanUnitFromJSONTyped(json, false);
}

export function PlanUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'idClient': json['idClient'],
        'name': json['name'],
        'workouts': ((json['workouts'] as Array<any>).map(PlanWorkoutFromJSON)),
        'nextUnitId': json['nextUnitId'] == null ? undefined : json['nextUnitId'],
        'repeatCount': json['repeatCount'] == null ? undefined : json['repeatCount'],
        'description': json['description'] == null ? undefined : json['description'],
        'sortKey': json['sortKey'],
        'trainingDateIso': json['trainingDateIso'] == null ? undefined : json['trainingDateIso'],
        'link': json['link'] == null ? undefined : HTTPLinkFromJSON(json['link']),
    };
}

export function PlanUnitToJSON(json: any): PlanUnit {
    return PlanUnitToJSONTyped(json, false);
}

export function PlanUnitToJSONTyped(value?: PlanUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idClient': value['idClient'],
        'name': value['name'],
        'workouts': ((value['workouts'] as Array<any>).map(PlanWorkoutToJSON)),
        'nextUnitId': value['nextUnitId'],
        'repeatCount': value['repeatCount'],
        'description': value['description'],
        'sortKey': value['sortKey'],
        'trainingDateIso': value['trainingDateIso'],
        'link': HTTPLinkToJSON(value['link']),
    };
}

